// removed by extract-text-webpack-plugin
module.exports = {"base":"Tabs_base--2MRzh","item":"Tabs_item--3ogmn","item__selected":"Tabs_item__selected--3_cGD","itemSelected":"Tabs_item__selected--3_cGD","overlay":"Tabs_overlay--2Gx3H","caption":"Tabs_caption--WcgFt"};


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/Tabs/Tabs.scss
// module id = 544
// module chunks = 11 14